import React, { useState, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Spin, Form, Input, Button } from 'antd';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import Message from '../../component/message/message';
import trans from './translation';
import './forgotPassword.css';

import loginLogoImg from '../../public/img/loginLogo.png';

const ForgotPassword = (props) => {

    const history = useHistory();
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        if(!Base.stopClick(2000) || loading) {
            return;
        }
        messageShowHandler();
        setLoading(true);
        fetch(Config.apiServer + "forgotUser/forgotPassword", {
            method: 'POST',
            body: JSON.stringify(values.userCode ?? ''),
            headers: Config.headers,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                form.resetFields();
                errFrameShow("success", trans.send[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setLoading(false));
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    return (
        <div className='forgotPassword'>
            <div className='logoBox'>
            <img src={loginLogoImg} />
                <div className='helpLoginBtn sysUpdate ' onClick={() => history.replace("/login")}>{trans.login[Config.backLang]}</div>
            </div>
            <div className='line'></div>
            <div className='forgotPasswordBackground'>
                {/* 错误信息弹框 */}
                <div className='forgotPasswordMessageBox'>
                    <Message ref={messageRef} />
                </div>
                <Spin spinning={loading}>
                    <div className='forgotPasswordBox'>
                        <div className="textBox">
                            <Form form={form} onFinish={onFinish}>
                                <div className='forgotPasswordTitleTop'>{trans.forgotPpassword[Config.backLang]}</div>
                                <div className='forgotPasswordInfo'>{trans.forgotPasswordInfo[Config.backLang]}</div>
                                <div className='forgotPasswordInfo'>{trans.forgotPasswordPartner[Config.backLang]}</div>
                                <Form.Item
                                    name="userCode"
                                    getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}//替換非空格
                                >
                                    <Input maxLength={50} style={{ backgroundColor: '#FFFFFF' }} className="forgotPasswordInput" placeholder={trans.userName[Config.backLang]} />
                                </Form.Item>

                                <div className='btnBox'>
                                    <Button type="primary" htmlType="submit" className="forgotPasswordSmbBtn" disabled={loading}>{trans.submit[Config.backLang]}</Button>
                                    <Button onClick={() => history.replace("/login")} className="forgotPasswordBackBtn" disabled={loading}>{trans.back[Config.backLang]}</Button>
                                </div>

                            </Form>
                        </div>
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export default ForgotPassword;